import { Input } from './input'

export class MultipleChoiceInput extends Input {
    constructor(language: string, inputData?: Partial<Input>) {
        super(language, inputData)
        this.kind = inputData?.kind ? inputData.kind : 'radioGroup'
        if (inputData?.renderHint) {
            this.renderHint = inputData.renderHint
        } else if (this.kind === 'radioGroup') {
            this.renderHint = 'radio'
        } else if (this.kind === 'checkboxGroup') {
            this.renderHint = 'checkbox'
        }

        this.icon = 'fa fa-ballot-check'
        this.supportScoring = true

        if (!inputData) {
            this.weight = 1
            this.addItem()
        }
    }
}
